export function invokeBridgeApi(callback) {
  // eslint-disable-next-line no-undef
  if (typeof WeixinJSBridge == "object" && typeof WeixinJSBridge.invoke == "function") {
    callback()
  } else {
    if (document.addEventListener) {
      document.addEventListener("WeixinJSBridgeReady", callback, false)
    } else if (document.attachEvent) {
      document.attachEvent("WeixinJSBridgeReady", callback)
      document.attachEvent("onWeixinJSBridgeReady", callback)
    }
  }
}

export function hideOptionMenu() {
  invokeBridgeApi(() => {
    // eslint-disable-next-line no-undef
    WeixinJSBridge.invoke("hideOptionMenu", {}, function(res) {
      console.log(JSON.stringify(res))
    })
  })
}
